import React, {useContext} from "react";
import {userInfoContext, azureTokenContext, userIdContext} from "../App";
import {useMsal} from "@azure/msal-react";

import LogoContainer from "./Serving/LogoContainer";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import {useLogMetric} from "../hooks/useLogMetric";
import {log} from "./Serving/ApiCalls";

import "../style/topBar.css";
import {Link} from "react-router-dom";

export default function TopBar() {
    const [userInfo] = useContext(userInfoContext);
    const azureToken = useContext(azureTokenContext);
    const userId = useContext(userIdContext);
    const {instance} = useMsal();
    const logMetric = useLogMetric();

    const handleLogout = () => {
        logMetric({category: "Authentication", subCategory: "Logout", message: "User clicked logout button"});
        instance.logoutRedirect().catch((e) => {
            const errorMessage = e instanceof Error ? e.message : String(e);
            log("ERROR", `Logout failed: ${errorMessage}`, "AuthorsPortal", "", "", userId, azureToken);
        });
    };

    return (
        <div className="TopBar">
            <div className="leftAlignedItems">
                <LogoContainer/>
            </div>
            <div className="rightAlignedItems">
                <div className="menu-profile-card">
                    {userInfo.ImageUrl && userInfo.ImageUrl.trim() !== '' ? (
                        <img 
                            className="profile-image-menu" 
                            src={userInfo.ImageUrl} 
                            alt="Profile"
                            onError={(e) => {
                                e.currentTarget.src = `${process.env.PUBLIC_URL}/no-profile-image.png`;
                            }}
                        />
                    ) : (
                        <img 
                            className="profile-image-menu" 
                            src={`${process.env.PUBLIC_URL}/no-profile-image.png`}
                            alt="Profile"
                        />
                    )}

                    <div className="profile-info-container">
                        <div className="profile-name">{userInfo.Name}</div>
                        <div className="edit-profile-link-div">
                            <Link className="edit-profile-link" to="/profile" onClick={() => logMetric({category: "Navigation", subCategory: "Profile link clicked", message: "User navigated to profile page"})}>
                                <button className="edit-profile-button">Profil og royalty</button>
                            </Link>
                        </div>
                    </div>
                </div>
                <button className="logout-icon-button" onClick={handleLogout} title="Logg ut">
                    <LogoutOutlinedIcon />
                </button>
            </div>
        </div>
    );
}
